module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/track_email_open.png"